<template>
  <div>

    <div :class="['overlay', {dark: isBGDark}]"></div>

    <div class="cover-container">
      <v-img
          height="352"
          :src="settings && settings.cover_image || require('@/assets/img/base/bg-blur.jpg')" />
    </div>

    <div class="logo-container">
      <v-avatar size="80">
        <v-img :src="logo" />
      </v-avatar>
    </div>

    <div class="actions">
      <appointment-picker
          v-if="settings && settings.allow_public_scheduling"
          :start-on-load="startScheduleOnLoad"
          :disable-close-modal="disableCloseModal"
          :redirect-url="redirectUrl"
          :provider="provider" />
    </div>

    <div class="title-wrapper">
      <v-layout wrap>
        <v-flex xs12 text-center>
          <h1 :class="['header-title', {'display-3': $vuetify.breakpoint.mdAndUp}, {'display-1': $vuetify.breakpoint.smAndDown}, {'white--text': isBGDark}, {'black--text': !isBGDark}]">
            {{providerName}}
          </h1>
        </v-flex>
      </v-layout>
    </div>

    <div class="description-wrapper">
      <v-layout wrap>
        <v-flex xs12 md10 offset-md1 lg8 offset-lg2 xl6 offset-xl3 pa-2>
          <v-card class="top-card py-4 px-3" min-height="200">
            <v-card-title>
              <profile-sub-tittle :text="about" />
            </v-card-title>
            <v-card-text class="px-4 py-3">
              <h1 :class="['headline text-center', {'description-mobile': $vuetify.breakpoint.smAndDown}]" v-html="description"></h1>
            </v-card-text>
            <v-card-actions>
              <v-flex xs12 text-center class="py-0">

                <template v-for="(number, i) in phoneNumbers">
                  <v-chip color="grey lighten-3"  @click="callTo(number)" label small  :key="i" v-if="$vuetify.breakpoint.mdAndUp">
                    <v-icon left>fa-phone-square</v-icon>
                    {{`+56${number}`}}
                  </v-chip>
                  <v-btn depressed fab small :key="i" @click="callTo(number)" v-else>
                    <v-icon>fa-phone-square</v-icon>
                  </v-btn>
                </template>


                <a :href="settings.facebook_url" target="_blank" v-if="settings && settings.facebook_url">
                  <v-chip color="grey lighten-3"  label small v-if="$vuetify.breakpoint.mdAndUp">
                    <v-icon left color="#3b5998">
                      fab fa-facebook-square
                    </v-icon>
                    {{settings.facebook_url.replace(/^https?:\/\/(www\.facebook.com)?/, '')}}
                  </v-chip>
                  <v-btn depressed fab small v-else>
                    <v-icon color="#3b5998">
                      fab fa-facebook-square
                    </v-icon>
                  </v-btn>
                </a>

                <a :href="settings.instagram_url" target="_blank" v-if="settings && settings.instagram_url">
                  <v-chip color="grey lighten-3"  label small v-if="$vuetify.breakpoint.mdAndUp">
                    <v-icon left color="#E1306C">
                      fab fa-instagram
                    </v-icon>
                    {{settings.instagram_url.replace(/^https?:\/\/(www\.instagram.com)?/, '')}}
                  </v-chip>
                  <v-btn depressed fab small v-else>
                    <v-icon color="#E1306C">
                      fab fa-instagram
                    </v-icon>
                  </v-btn>
                </a>

                <a :href="settings.linkedin_url" target="_blank" v-if="settings && settings.linkedin_url">
                  <v-chip color="grey lighten-3"  label small v-if="$vuetify.breakpoint.mdAndUp">
                    <v-icon left color="#0e76a8">
                      fab fa-linkedin
                    </v-icon>
                    {{settings.linkedin_url.replace(/^https?:\/\/(www\.linkedin.com)?/, '')}}
                  </v-chip>
                  <v-btn depressed fab small v-else>
                    <v-icon color="#0e76a8">
                      fab fa-linkedin
                    </v-icon>
                  </v-btn>
                </a>

              </v-flex>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </div>

  </div>
</template>

<script>
import AppointmentPicker from "@/components/providers/profile/AppointmentPicker";
import {isImageDark, getFakeAvatar} from "@/utils/Common";
import ProfileSubTittle from "@/components/providers/profile/ProfileSubTittle";

export default {
  name: "ProfileHeader",
  components: {ProfileSubTittle, AppointmentPicker},
  props:{
    provider: {
      type: Object,
      required: true
    },
    startScheduleOnLoad: {
      type: Boolean,
      default: false
    },
    disableCloseModal: {
      type: Boolean,
      default: false
    },
    redirectUrl: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      isBGDark: false
    }
  },
  mounted(){
    const vm = this
    if(vm.provider && vm.provider.settings && vm.provider.settings.cover_image){
      isImageDark(vm.provider.settings.cover_image, function(isDark){
        vm.isBGDark = isDark
      })
    }
  },
  computed:{
    logo(){
      const vm = this
      if(vm.institution){
        return vm.provider.settings.avatar_image || require('@/assets/img/logo_placeholder.png')
      }else{
        return vm.provider.user && vm.provider.user.avatar || getFakeAvatar(vm.provider.user.gender)
      }
    },
    about(){
      const vm = this
      if(vm.institution){
        return 'Sobre nosotros'
      }

      return 'Acerca de mí'

    },
    institution(){
      const vm = this
      return vm.provider && vm.provider.institution || null
    },
    mainOffice(){

      const vm = this

      if(!vm.provider.institution) return null

      let {branch_offices} = vm.provider.institution
      let mainOffice = branch_offices.find(office => office.main)
      if(!mainOffice && branch_offices.length > 0){
        mainOffice = branch_offices[0]
      }

      return mainOffice

    },
    phoneNumbers(){
      const vm = this
      let numbers = []
      if(!vm.provider.institution){

        if(vm.provider.user && vm.provider.phone1){
          numbers.push(vm.provider.user.phone1)
        }

        if(vm.provider.user && vm.provider.phone2){
          numbers.push(vm.provider.user.phone2)
        }

      }else{

        if(vm.mainOffice){
          if(vm.mainOffice.phone1)
            numbers.push(vm.mainOffice.phone1)

          if(vm.mainOffice.phone2)
            numbers.push(vm.mainOffice.phone2)
        }

      }

      return numbers

    },
    settings(){
      const vm = this
      return vm.provider && vm.provider.settings || null
    },
    providerName(){
      const vm = this
      return (vm.provider.institution ? vm.provider.institution.name : `${vm.provider.user.first_name} ${vm.provider.user.last_name}.`) || ''
    },
    description(){
      const vm = this
      return (vm.provider && vm.provider.description || 'Proveedor de Servicios en <b>Kim</b>app').replace(/\n/g, '<br/>')
    }
  },
  methods:{
    callTo(number){
      if(!number) return
      window.location.href = `tel://+56${number}`
    }
  }
}
</script>

<style scoped>

.headline{
  font-size: 20px !important;
  font-weight: 300;
  line-height: 26px !important;
}

.description-mobile{
  font-size: 16px !important;
  line-height: 22px !important;
}

.avatar{
  position: absolute;
  margin: auto;
  top: -40px;
  left: calc(50% - 40px);
  box-shadow: 10px 10px 40px rgba(0,0,0,.6);
}

.header-title{
  font-weight: 300;
}

.overlay{
  position: absolute;
  top: 0;
  left: 0;
  height: 352px;
  width: 100%;
  z-index: 1;
  background: rgb(255,255,255);
  background: linear-gradient(0deg, rgba(255,255,255, 1) 20%, rgba(255,255,255,0.25) 100%);
}

.overlay.dark{
  background: rgb(0,0,0);
  background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.2558067172181373) 100%);
}

.title-wrapper{
  position: relative;
  z-index: 1;
  margin-top: 80px;
  font-family: Montserrat, sans-serif;
}

.actions{
  position: fixed;
  top: 0;
  right:0;
  width: 50%;
  height: 70px;
  text-align: right;
  padding: 10px;
  z-index: 3;
}

.logo-container{
  position: fixed;
  top: 0;
  left:0;
  width: 50%;
  height: 70px;
  text-align: left;
  padding: 10px;
  z-index: 3;
}

.top-card{
  box-shadow: 30px 30px 50px rgba(0,0,0,.3) !important;
  border: none !important;
  border-radius: 20px !important;
}

.top-card{
  background: #f5f5f5 !important;
}

.description-wrapper{
  position: absolute;
  top: 210px;
  left:0;
  width: 100%;
  z-index: 2;
}

  .cover-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

</style>
